import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.jpeg';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="CSR Financial Solutions" />
              <div className="footer-logo-text">
                <span className="t1">CSR's Financial Solutions</span>
                <span className="t2">Private Limited</span>
              </div>
            </div>
            <p className="footer-desc">
              Bangalore's trusted outsourcing partner for BPO, KPO, debt recovery, and HR solutions. Delivering measurable results since 2012.
            </p>
            <div className="footer-socials">
              {[
                ['fab fa-linkedin-in', '#'],
                ['fab fa-twitter', '#'],
                ['fab fa-instagram', '#'],
                ['far fa-envelope', 'mailto:info@csrfinancial.in'],
              ].map(([icon, href], i) => (
                <a key={i} href={href} className="social-link" target="_blank" rel="noreferrer">
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-col">
            <h4>Navigation</h4>
            <ul>
              {[
                ['/', 'fa-home', 'Home'],
                ['/services', 'fa-layer-group', 'Services'],
                ['/about', 'fa-building', 'About Us'],
                ['/blog', 'fa-newspaper', 'Blog'],
                ['/contact', 'fa-envelope', 'Contact'],
              ].map(([path, icon, label]) => (
                <li key={path}>
                  <Link to={path}><i className={`fas ${icon}`}></i>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              {[
                ['fa-headset', 'BPO Services'],
                ['fa-brain', 'KPO Services'],
                ['fa-users-cog', 'HR Outsourcing'],
                ['fa-file-invoice-dollar', 'Debt Recovery'],
                ['fa-phone', 'Call Center'],
                ['fa-globe', 'Global Outsourcing'],
              ].map(([icon, label], i) => (
                <li key={i}>
                  <Link to="/services"><i className={`fas ${icon}`}></i>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <div className="footer-contact">
              <div className="fc-item"><i className="fas fa-map-marker-alt"></i><span>No 67, 1st floor, 5th Cross, 3rd Main Chamarajpet, Bangalore, Karnataka, India — 560018</span></div>
              <div className="fc-item"><i className="fas fa-phone-alt"></i><span>08026601556</span></div>
              <div className="fc-item"><i className="fas fa-envelope"></i><span>contactus@csrfinancialsolutions.com</span></div>
              <div className="fc-item"><i className="fas fa-clock"></i><span>Mon–Sat: 9:00 AM – 7:00 PM IST</span></div>
            </div>
            <div style={{marginTop:'24px'}}>
              <a
                href="https://wa.me/919008328891"
                target="_blank"
                rel="noreferrer"
                style={{display:'inline-flex',alignItems:'center',gap:'8px',background:'#25D366',color:'#fff',fontSize:'0.78rem',padding:'10px 18px',borderRadius:'4px',fontFamily:'var(--sans)',fontWeight:500,transition:'all 0.3s ease'}}
              >
                <i className="fab fa-whatsapp" style={{fontSize:'1rem'}}></i> WhatsApp Us
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© 2024 <span>CSR's Financial Solutions Pvt. Ltd.</span> — All rights reserved.</p>
          <div className="footer-badge">Est. 2012 · Bangalore, India</div>
        </div>
      </div>
    </footer>
  );
}
